<template>
  <div>
    {{ linkText }}
  </div>
</template>

<script>
export default {
  name: "ProposalSourceTooltip",
  props: {
    value: {
      type: String,
      default: "-",
    },
    row: Object,
    column: Object,
  },
  computed: {
    linkText() {
      try {
        const url = new URL(this.value);
        return url.host;
      } catch {
        return this.value ?? "-";
      }
    },
  },
};
</script>

<style scoped lang="less"></style>
